var storage = { //数据存储
        set(key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        get(key) {
            return JSON.parse(localStorage.getItem(key));
        },
        remove(key) {
            localStorage.removeItem(key);
        }
    }
    //暴露给外部访问
export default storage;


// WEBPACK FOOTER //
// ./src/util/storage.js